// @actions
const signaturePatternActions = require('actions/signaturePattern');

// @helpers
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const {
    CARDS_CANCEL_DEFER_PURCHASE_FAILURE,
    CARDS_CANCEL_DEFER_PURCHASE_INPROGRESS,
    CARDS_CANCEL_DEFER_PURCHASE_SET_VISIBLE_STEP,
    CARDS_CANCEL_DEFER_PURCHASE_SUCCESS,
    CARDS_CANCEL_DEFER_PURCHASE_VALIDATE_STEP,
    CARDS_CANCEL_DEFER_PURCHASE_WILL_CANCEL,
    CARDS_GET_CANCEL_DEFER_PURCHASE_INFO_ERROR,
    CARDS_GET_CANCEL_DEFER_PURCHASE_INFO_INPROGRESS,
    CARDS_GET_CANCEL_DEFER_PURCHASE_INFO_SUCCESS,
    RESET_CARDS_CANCEL_DEFER_PURCHASE,
} = require('constants/actionTypes');

const validateStep = (step) => ({
    type: CARDS_CANCEL_DEFER_PURCHASE_VALIDATE_STEP,
    payload: {
        step
    }
});

function reset() {
    return {
        type: RESET_CARDS_CANCEL_DEFER_PURCHASE
    };
}

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: CARDS_CANCEL_DEFER_PURCHASE_SET_VISIBLE_STEP,
        payload: { step }
    });
};

const getCancelDeferPurchaseInfoError = (error) => ({
    type: CARDS_GET_CANCEL_DEFER_PURCHASE_INFO_ERROR,
    payload: {
        error
    }
});

const cancelCardDeferPurchaseSuccess = (response) => {
    return {
        type: CARDS_CANCEL_DEFER_PURCHASE_SUCCESS,
        payload: {
            response
        }
    };
};

const cancelCardDeferPurchaseError = (error) => ({
    type: CARDS_CANCEL_DEFER_PURCHASE_FAILURE,
    payload: {
        error
    }
});

const cancelDeferPurchaseFetching = () => ({
    type: CARDS_CANCEL_DEFER_PURCHASE_INPROGRESS
})

const cancelCardDeferPurchase = (dispatch, getState, token, cardId, movementId) => {
    const immCardCancelDeferInfo = getState().cardCancelDeferPurchase;
    const immCardCancelDeferData = immCardCancelDeferInfo.get('cancelDeferPurchaseData');
    const immMovement = getState().cardsTransactions.getIn([cardId, 'byId', movementId]);
    const typeOfBalance = immMovement.getIn(['extra', 'balanceConcept']);
    const pan = getState().cards.getIn(['byId', cardId, 'number']);
    const dayMovementNumber = immMovement.getIn(['extra', 'dayMovementNumber']);
    const params = {
        query: {
            dateOfOperacion: immMovement.getIn(['extra', 'operationDate']),
            diamovto: dayMovementNumber,
            divisa: immCardCancelDeferData.getIn(['importeCapitalPend', 'divisa']),
            fechaAnotacion: immMovement.getIn(['extra', 'movementNoteDay']),
            importe: immMovement.getIn(['import', 'amount']),
            numerodecontrato: immCardCancelDeferData.getIn(['contratoTarjeta', 'numerodecontrato']),
            pan: pan,
            producto: immCardCancelDeferData.getIn(['contratoTarjeta', 'producto']),
            tipoSaldo: typeOfBalance,
            dataToken: token
        }
    };
    dispatch(cancelDeferPurchaseFetching());
    return APIPost({
        dispatch,
        endpoint: 'cardCancelDeferPurchase',
        params: params
    })
        .then(response => {
            dispatch(cancelCardDeferPurchaseSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(cancelCardDeferPurchaseError(response.error));
            } else {
                throw response;
            }
        });
};

const getCancelDeferPurchaseInfoSuccess = (response) => ({
    type: CARDS_GET_CANCEL_DEFER_PURCHASE_INFO_SUCCESS,
    payload: {
        response,
    }
});

const getCancelDeferPurchaseInfoFetching = () => ({
    type: CARDS_GET_CANCEL_DEFER_PURCHASE_INFO_INPROGRESS,
});

const getCancelDeferPurchaseInfo = (cardId, movementId, immCardsTransactions) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId], false);
    const immMovement = immCardsTransactions.getIn([cardId, 'byId', movementId]);
    const typeOfBalance = immMovement.getIn(['extra', 'balanceConcept']);
    const pan = immCard.get('number');
    const dayMovementNumber = immMovement.getIn(['extra', 'dayMovementNumber']);
    const params = {
        query: {
            conceptoSaldo: typeOfBalance,
            dateOfOperation: immMovement.getIn(['extra', 'operationDate']),
            divisa: immMovement.getIn(['import', 'currency']),
            fechaAnotacion: immMovement.getIn(['extra', 'movementNoteDay']),
            hourOfOperation: immMovement.get('time'),
            importe: immMovement.getIn(['import', 'amount']),
            numeroMovimintoEnDia: dayMovementNumber,
            numerodecontrato: immCard.getIn(['contract', 'number']),
            pan: pan,
            producto: immCard.getIn(['product', 'type'])
        }
    };

    dispatch(getCancelDeferPurchaseInfoFetching());

    return APIPost({
        dispatch,
        endpoint: 'getDeferPurchaseCancellationCost',
        params: params
    })
        .then(response => {
            dispatch(getCancelDeferPurchaseInfoSuccess(response.methodResult));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getCancelDeferPurchaseInfoError(response.error));
            } else {
                throw response;
            }
        });
};

const validateSignature = (dispatch, getState, cardId, movementId) => {
    signaturePatternActions.validateAndExecute(
        dispatch,
        getState,
        (dispatch, getState, token) => cancelCardDeferPurchase(dispatch, getState, token, cardId, movementId)
    );
};

const finish = (cardId, movementId) => (dispatch, getState) => {
    validateSignature(dispatch, getState, cardId, movementId)
};

const setWillCancel = (willCancel) => ({
    type: CARDS_CANCEL_DEFER_PURCHASE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

module.exports = {
    finish,
    getCancelDeferPurchaseInfo,
    reset,
    setVisibleStep,
    setWillCancel,
    validateStep,
};
